import { IMultiUserListSelectorDialogCondition, instanceOfIMultiUserListSelectorDialogCondition } from "./IMultiUserListSelectorDialogCondition";

export interface IMultiOrderableUserListSelectorDialogCondition extends IMultiUserListSelectorDialogCondition {
}

export function instanceOfIMultiOrderableUserListSelectorDialogCondition(instance: any): instance is IMultiOrderableUserListSelectorDialogCondition {
  return instance
    && instanceOfIMultiUserListSelectorDialogCondition(instance);
}
